export default __webpack_public_path__ + "static/media/student.b3382cdc.png";